@if (billAccount) {
  <div>
    <p
      class="pad-bottom-20"
      dsContent
      [contentPath]="'billing.updateBillAccountPreferences'"
      applicationDependentCopy="true"
    ></p>
    @if (!hasAutopayEnabled && autopayEligible) {
      <p class="pad-bottom-20">
        <span dsContent [contentPath]="'billing.updateBillAccountPreferencesAutopayPre'"></span>
        <a href="javascript:void(0);" (click)="navigateToAutoPay()">
          <span dsContent [contentPath]="'billing.updateBillAccountPreferencesAutopayLink'"></span>
        </a>
        <span dsContent [contentPath]="'billing.updateBillAccountPreferencesAutopayPost'"></span>
      </p>
    }
    @if (isAdminApp) {
      <p
        class="pad-bottom-20"
        dsContent
        [contentPath]="'billing.myaccountadmin.preferenceEmailReminder'"
      ></p>
    }
    @if (billAccount) {
      <ds-billing-online-preference
        [hasAutopayEnabled]="hasAutopayEnabled"
        [billAccount]="billAccount"
      >
      </ds-billing-online-preference>
    }
  </div>
}
